<template>
	<div class="login-box" :style="{backgroundImage:'url('+require('../assets/welcome_bg.jpg')+')'}">
		<div class="login-card">
			<div class="login-form">
				<div class="title">合作商登录</div>
				<div v-if="loading" class="loading" v-loading="true"></div>
				<template v-else>
					<el-form label-position="top" :model="loginForm" :rules="from_rules" ref="loginForm"
						label-width="100px">
						<el-form-item label="手机号" prop="phone">
							<el-input v-model="loginForm.phone" placeholder="请输入手机号码" maxlength="11" clearable />
						</el-form-item>
						<el-form-item label="验证码" prop="code">
							<div style="display: flex;justify-content: center;align-items: center;">
								<div style="flex: 1;">
									<el-input v-model="loginForm.code" placeholder="请输入验证码" maxlength="6" clearable />
								</div>
								<div style="margin-left: 0.5rem;">
									<img style="vertical-align: middle;cursor: pointer;" :src="loginForm.imgcode"
										@click="postCaptcha" />
								</div>
							</div>
						</el-form-item>
						<el-form-item label="短信验证码" prop="vecode">
							<el-input v-model="loginForm.vecode" placeholder="6位短信验证码" maxlength="6" clearable>
								<div slot="append" @click="onMessage('loginForm')" :class="!vecodeCheck?'ok':''">
									<div v-if="vecodeLoading">
										<i class="el-icon-loading"></i>
										<span>发送中...</span>
									</div>
									<div v-else>{{vecodeText}}</div>
								</div>
							</el-input>
						</el-form-item>
						<div class="login-footer">
							<el-button type="primary" @click="submitForm" :loading="loginLoading">登 录</el-button>
						</div>
						<div class="login-copy">技术维护 @漳浦佳智网络</div>
					</el-form>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	var timer = null;
	export default {
		data() {
			return {
				loading: true,
				loginForm: {
					phone: '',
					code: '',
					vecode: '',
					imgcode: '',
					codekey: ''
				},
				from_rules: {
					phone: [{
							required: true,
							message: '手机号码必填'
						},
						{
							validator(rule, value, callback) {
								var reg = /^1[3|4|5|6|7|8|9]\d{9}$/
								if (reg.test(value)) {
									callback()
								} else {
									callback(new Error('请正确输入11位手机号码'))
								}
							},
							trigger: 'blur'
						}
					],
					code: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}],
					vecode: [{
							required: true,
							message: '请输入短信验证码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 6,
							message: '验证码长度为6位数字',
							trigger: 'blur'
						}
					]
				},
				vecodeCheck: false,
				vecodeLoading: false,
				vecodeText: "获取验证码",
				loginLoading: false
			};
		},
		mounted() {
			this.postCaptcha();
		},
		methods: {
			postCaptcha() {
				const that = this;
				that.$post('passportLogin', {
					mode: "captcha"
				}).then(res => {
					that.loading = false;
					that.loginForm.codekey = res.data.codekey;
					that.loginForm.imgcode = that.$apiUrl + "/passport/captcha?codekey=" + res
						.data.codekey;
				}).catch(e => {
					that.$alert((e.message) ? e.message : "页面加载失败，请刷新重试", '提示');
				});
			},
			onMessage() {
				const that = this;
				var checkphone = false,
					checkcode = false;
				if (that.vecodeCheck || that.vecodeLoading) return;
				that.$refs.loginForm.clearValidate();
				that.$refs.loginForm.validateField("phone", (valid) => {
					if (!valid) {
						checkphone = true;
					}
				});
				that.$refs.loginForm.validateField("code", (valid) => {
					if (!valid) {
						checkcode = true;
					}
				});
				if (checkphone && checkcode) {
					that.vecodeLoading = true;
					that.$post('passportLogin', {
						mode: "vecode",
						phone: that.loginForm.phone,
						code: that.loginForm.code,
						codekey: that.loginForm.codekey
					}).then(res => {
						let time = 120;
						that.vecodeCheck = true;
						that.vecodeLoading = false;
						that.$message.success("发送成功");
						that.vecodeText = time + '秒后重试';
						timer = setInterval(() => {
							if (time == 0) {
								clearInterval(timer);
								that.vecodeCheck = false;
								that.vecodeText = '重新获取';
							} else {
								time--;
								that.vecodeText = time + '秒后重试';
							}
						}, 1000);
					}).catch(e => {
						that.vecodeLoading = false;
						that.$message.error((e.message) ? e.message : "未知错误，请重试");
					});
				}
			},
			submitForm() {
				const that = this;
				that.$refs.loginForm.validate((valid) => {
					if (valid) {
						that.loginLoading = true;
						that.$post('passportLogin', {
							phone: that.loginForm.phone,
							vecode: that.loginForm.vecode
						}).then(res => {
							that.$notify({
								title: '登录成功',
								message: '正在进入合作商后台...',
								type: 'success',
								onClose: function() {
									localStorage.setItem("_JIAZHI_token", res
										.data.token);
									localStorage.setItem("_JIAZHI_info", JSON
										.stringify(res
											.data.info));
									that.$router.push({
										path: '/console'
									});
								}
							});
						}).catch(e => {
							that.loginLoading = false;
							that.$message.error((e.message) ? e.message : "未知错误，请重试");
						});
					} else {
						return false;
					}
				});

			}
		}
	}
</script>

<style scoped>
	.login-box {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-repeat: no-repeat;
		background-size: cover;
		background-color: #f9f9f9;
	}

	.login-box:before {
		content: '';
		position: absolute;
		width: 100%;
		height: 100%;
		opacity: 0.85;
		background-image: linear-gradient(127deg, #384DFF 0%, #24CDFF 91%);
		z-index: 3;
	}

	.login-card {
		background: #fff;
		box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1000;
	}

	.login-form {
		padding: 0 3rem;
		margin: 1.875rem auto;
	}

	.login-form .title {
		text-align: center;
		font-size: 1.5rem;
		font-weight: bold;
		margin-bottom: 2.5rem;
		position: relative;
	}

	.login-form .loading {
		width: 18.75rem;
		min-height: 12.5rem;
	}

	.login-form .el-form {
		width: 18.75rem;
	}

	.login-form>>>.el-form-item__label {
		padding: 0 !important;
		line-height: 1.875rem;
		margin-top: 0.3rem;
	}

	.login-form>>>.el-form-item__content .el-input-group__append {
		width: 5rem;
		text-align: center;
		cursor: pointer;
	}

	.login-form>>>.el-form-item__content .el-input-group__append .ok {
		color: #000000;
	}

	.login-footer {
		display: flex;
		margin: 3.125rem auto 1rem auto;
	}

	.login-footer button {
		flex: 1;
	}

	.login-copy {
		color: #ccc;
		text-align: center;
		font-size: 0.75rem;
	}
</style>
